/**
 * @file Created on Wed Aug 22 2018
 * @author BPo
 */
import { OptionsProvider } from './OptionsProvider';
export default OptionsProvider;